export class CmsFetchError extends Error {
  readonly resource: string;

  constructor(resource: string, options?: { cause?: unknown }) {
    super(`Failed to load CMS data: ${resource}`);
    this.name = "CmsFetchError";
    this.resource = resource;
    if (options?.cause !== undefined) {
      this.cause = options.cause;
    }
  }
}

export function isCmsFetchError(error: unknown): error is CmsFetchError {
  return error instanceof CmsFetchError;
}
